module.exports = __webpack_public_path__ + "img/Kenya.6ce35d03.png";